<template>
    <v-dialog 
        :value="show"
        max-width="600" 
        persistent
        transition="dialog-bottom-transition">
        <v-card v-if="rateCopy != null">
            <v-toolbar dark color="primary">
                <v-btn 
                    icon 
                    dark 
                    :disabled="saving" 
                    @click="cancel">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    <span>Edit Rate</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            
            <v-form ref="editForm" v-model="editValid">
                <v-laout class="dialog-content">
                    <v-flex xs12>
                        <v-menu v-model="rateEffectiveDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field :value="formatDateYMD(rateCopy.EffectiveDate)" label="Effective Date" prepend-icon="event" readonly v-on="on" :rules="[rules.required]"></v-text-field>
                            </template>
                            <v-date-picker :value="formatDateYMD(rateCopy.EffectiveDate)" @input="updateEffectiveDate($event)"></v-date-picker>
                        </v-menu>
                        <v-text-field 
                            label="Default Pay Rate Per Hour"
                            v-model="rateCopy.DefaultPayRatePerHour"
                            prepend-icon="attach_money"
                            :rules="[rules.requiredNumber, rules.number({ min: 0, max: 1000000, decimalPlaces: 2 })]"
                        >
                        </v-text-field>
                        <v-text-field 
                            label="Default Allowance Pay Rate Per Hour"
                            v-model="rateCopy.DefaultAllowancePayRatePerHour"
                            prepend-icon="attach_money"
                            :rules="[rules.number({ min: 0, max: 100, decimalPlaces: 2 })]"
                        >
                        </v-text-field>
                    </v-flex>
                </v-laout>
                <v-layout class="dialog-content">
                    <v-flex xs12>
                        <v-layout wrap class="dialog-action-buttons">
                            <v-flex xs12 sm6>
                                <v-btn 
                                    block 
                                    color="success" 
                                    :disabled="!editValid" 
                                    :loading="saving" 
                                    @click="confirm">
                                    <span>Confirm</span>
                                </v-btn>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex xs12 sm6>
                                <v-btn 
                                    block 
                                    color="error" 
                                    :disabled="saving" 
                                    @click="cancel">
                                    <span>Cancel</span>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-alert 
                                    :value="error" 
                                    outline 
                                    type="error">
                                    <span>{{ error }}</span>
                                </v-alert>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-form>
           
        </v-card>
    </v-dialog>
</template>

<script>
import ConfigurationAPI from "@/api/configurationApi";
import BaseAPI from "@/api/baseApi";
import moment from "moment";
import * as Constants from "@/helpers/constants";
import validationRules from "@/helpers/validationrules";
import UtilService from '@/services/utilService.js';

export default {
    props: {
        rate: {
            required: false,
            type: Object,
            default: null
        },
        show: {
            required: true,
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            moment,
            rateCopy: null,
            show: false,
            editValid: false,
            rateEffectiveDateMenu: false,
            rules: validationRules.rules,
        }
    },
    computed: {
        
    },
    mounted() {
        
    },
    methods: {
        cancel() {
            this.$emit("cancel", false);
        },
        confirm() {
            this.$emit("confirm", this.rateCopy);
        },
        open(){
            this.show = true;
        },
        formatDateYMD(v) {
            if(v) {
                return UtilService.formatDateYMD(v);
            } 
            return null;
        },
        updateEffectiveDate(value) {
            this.rateCopy.EffectiveDate = value;
            this.rateEffectiveDateMenu = false;
        },
    },
    watch: {
        show: {
            handler(newVal, oldVal) {
                if (newVal != oldVal && newVal) {
                    this.rateCopy = Object.assign({}, this.rate);
                }
                else {
                    this.rateCopy = null;
                }
            },
            deep: true
        },
    }
}
</script>